import ready from '../utils/ready';

const initializeContact = () => {
  document.querySelectorAll('[data-module-type="contacts"]').forEach((contactSection) => {
    contactSection.querySelectorAll('.toggle-list__btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        // Clear active state on other buttons
        const filterList = btn.closest('.toggle-list');
        if (!filterList) return;
        const siblings = filterList.querySelectorAll('.toggle-list__btn');

        for (let i = 0; i < siblings.length; i++) {
          if (siblings[i] === btn) {
            continue;
          }

          siblings[i].classList.remove('toggle-list__btn--is-active');
        }

        // Add active state to current button
        btn.classList.add('toggle-list__btn--is-active');

        // Filter contact list
        const filter = btn.getAttribute('data-filter');
        const gridItems = contactSection.querySelectorAll<HTMLDivElement>('.responsive-grid__item');

        gridItems.forEach((gridItem) => {
          if (
            filter === '' ||
            JSON.parse(gridItem.getAttribute('data-role') || '')?.indexOf(filter) > -1 ||
            JSON.parse(gridItem.getAttribute('data-department') || '')?.indexOf(filter) > -1 ||
            JSON.parse(gridItem.getAttribute('data-branch') || '')?.indexOf(filter) > -1
          ) {
            gridItem.style.display = 'block';
          } else {
            gridItem.style.display = 'none';
          }
        });
      });
    });
  });
};

ready(initializeContact);
